// Frontend mirror of lib/course-types.js. A hybrid event is a live course whose
// audience is split between Zoom and a venue, so every "is this live?" check must
// accept 'hybrid' too — comparing to the string 'live' silently excludes hybrids.
export const LIVE_LIKE_TYPES = ['live', 'hybrid'];

export function isLiveLike(courseType) {
  return LIVE_LIKE_TYPES.includes(courseType);
}

export function liveBadgeLabel(courseType) {
  return courseType === 'hybrid' ? 'Hybrid event · in person & online' : 'Live session';
}
